
// You can write more code here

/* START OF COMPILED CODE */

import Tile from "../../game/Tile";

/* START-USER-IMPORTS */
import {GameConfig} from "../../game/config/gameConfig";
import Game, {GameState} from "../../scenes/Game";
import Vector2 = Phaser.Math.Vector2;
import {LevelManager} from "../../game/LevelManager";
import { Sounds } from '../../sounds';
import { Sound } from "phaser";

export const TazAnimations = {
  Idle: 'idle',
  Start: 'start',
  Stop: 'stop',
  Spin: 'spin'
} as const;

export type TazAnimationsKeys = keyof typeof TazAnimations;
export type TazAnimationsValues = typeof TazAnimations[TazAnimationsKeys];

/* END-USER-IMPORTS */



export default class Taz extends window.SpinePlugin.SpineContainer {

  public levelManager!:LevelManager;

  private tazLaughs:string[] = [Sounds.Track.TazLaugh_2,Sounds.Track.TazLaugh_3,Sounds.Track.TazLaugh_4,Sounds.Track.TazLaugh_5];
  private lastTazLaugh:string ="";

  public static events = {
    MovementComplete:"MovementComplete",
    SpeedBoost:"SpeedBoost",
  } as const;

  constructor(scene: Phaser.Scene,levelManager : LevelManager, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene,scene.sys.spine,x??0,y??0);
    this.levelManager = levelManager;
    /* START-USER-CTR-CODE */
    this.taz = this.scene.add.spine(0,20, 'taz', TazAnimations.Idle, true);
    this.add(this.taz);
    
    // this.add(container);
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */
  public vx:number = 0;
  public vy:number = 0;
  public gameEngine!:Game;
  private taz:SpineGameObject;
  private manuallyStopped:boolean = false;
  private tazWhirlLoopReference:string="";
  private tazWhirlVolume:number = 0;
  private tazWhirlTime:number = 0;

  public applyForce()
  {
        let offset = this.scene.cameras.main.width - 1920;
        let p: Vector2 = new Phaser.Math.Vector2(this.x, this.y);
        let p1: Vector2 = new Phaser.Math.Vector2(this.scene.input.activePointer.x - offset / 2, this.scene.input.activePointer.y);
        let p2: Vector2 = new Phaser.Math.Vector2(this.scene.input.activePointer.x - offset / 2, this.scene.input.activePointer.y);
        let dir = p1.subtract(p).normalize();
        let dist = p2.distance(p);
        let distance = this.lerp(GameConfig.playerMinSpeed,GameConfig.playerMaxSpeed,dist/GameConfig.maxLineLength);

        this.vx = dir.x*distance;
        this.vy = dir.y*distance;

        this.taz.setAnimation(0,TazAnimations.Start,false);
        this.taz.addAnimation(0,TazAnimations.Spin,true);

        let sound = this.scene.sound.get(Sounds.Track.TazWhirlLoop);

        let laugh =  this.tazLaughs[Phaser.Math.Between(0,this.tazLaughs.length-1)];
        this.scene.app.AudioHandler.playSound(this.scene,laugh, Sounds.Channel.SFX, { volume: 1});
        this.lastTazLaugh = laugh;

        if(sound == null)
        {
            let soundData = this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.TazWhirlLoop, Sounds.Channel.SFX, { volume: 0, loop:true });
            this.tazWhirlLoopReference = soundData[0];
            this.tazWhirlVolume = 0;
            this.tazWhirlTime = 0;
            sound = this.scene.sound.get(Sounds.Track.TazWhirlLoop);
          this.scene.add.tween({
            targets:sound,
            volume:0.5,
            duration:100,
            ease:Phaser.Math.Easing.Quadratic.InOut,
          });
        }
  }

  private modifyingPlayerSpeed:boolean = false;
  public movePlayer(delta:number) {
    let prevX: number = this.x;
    let prevY: number = this.y;

    if(this.gameEngine.currentPowerup !== undefined && this.gameEngine.currentPowerup.AffectsPlayerSpeed())
    {
      if(!this.modifyingPlayerSpeed)
      {
        this.hitObjectThatIncreasesVelocity();
      }
      this.modifyingPlayerSpeed = true;
      let speed = this.gameEngine.currentPowerup.modifyPlayerSpeed(this.vx,this.vy);
      this.vx = speed.vx;
      this.vy = speed.vy;
    }
    else{
      this.modifyingPlayerSpeed = false;
    }

    //rescale the velocity of the player to be clamped in range
    let x = this.vx;
    let y = this.vy;
    let len = Math.sqrt(x * x + y * y);
    if(len > GameConfig.playerMaxVelocity)
    {
      len = 1 / len;

      x = x * len;
      y = y * len;
      x *= GameConfig.playerMaxVelocity;
      y *= GameConfig.playerMaxVelocity;

      this.vx = x;
      this.vy = y;
    }

    this.x += this.vx * (delta / 1000);
    this.y += this.vy * (delta / 1000);

    this.vx *= this.levelManager.Friction;
    this.vy *= this.levelManager.Friction;

    this.checkPlayerCollisisions(prevX,prevY);

    this.setDepth(this.y);
    this.taz.setDepth(this.y);

    if(Math.abs(this.vx) <= 15 && Math.abs(this.vy) <= 15)
    {
      this.taz.state.timeScale = 1;

      this.vx = 0;
      this.vy = 0;
      // this.gameEngine.PlayerMovementEnded();
      if(!this.manuallyStopped)
      {
        this.scene.events.emit(Taz.events.MovementComplete);
        let sound = this.scene.sound.get(Sounds.Track.TazWhirlLoop);
      if(sound != null && sound != undefined)
      {
        this.scene.add.tween({
          targets:sound,
          volume:0,
          duration:100,
          ease:Phaser.Math.Easing.Quadratic.InOut,
        }).on("complete",()=>{
          
          this.scene.app.AudioHandler.stopAndRemoveSound(this.tazWhirlLoopReference,Sounds.Channel.SFX);

          
        });
      }
      }
      this.taz.play(TazAnimations.Stop,false);
      this.taz.addAnimation(0,TazAnimations.Idle,true);

      
    }
    else
    {
      let t = ((((Math.abs(this.vx) + Math.abs(this.vy))/2)/GameConfig.playerMaxVelocity)*10);
      this.taz.state.timeScale = t+0.2;

      this.tazWhirlTime += delta/1000;
      this.tazWhirlTime = Math.min(this.tazWhirlTime,1);
      
      this.tazWhirlVolume = this.lerp(0,t+0.2,this.tazWhirlTime);
      this.scene.app.AudioHandler.setVolume(this.tazWhirlLoopReference,Sounds.Channel.SFX, Math.min(this.tazWhirlVolume,0.5) );
      

      let angle = this.lerp(-20,20,(this.vx/GameConfig.playerMaxVelocity)+0.5);
      
      this.taz.findBone("direction").rotation = 90+angle;
    }
  }
  private checkPlayerCollisisions(prevX:number, prevY:number)
  {
    if(this.x < this.levelManager.mapLeftBorder && this.vx < 0)
    {
      this.x = this.levelManager.mapLeftBorder;
      this.vx *= -1;
    }
    if(this.x > this.levelManager.mapRightBorder && this.vx > 0)
    {
      this.x = this.levelManager.mapRightBorder;
      this.vx *= -1;
    }

    if(this.y < this.levelManager.mapTopBorder && this.vy < 0)
    {
      this.y = this.levelManager.mapTopBorder;
      this.vy *= -1;
    }

    if(this.y > this.levelManager.mapBottomBorder && this.vy > 0)
    {
      this.y = this.levelManager.mapBottomBorder;
      this.vy *= -1;
    }

    let collisionData = this.levelManager.hitObject(this.x,this.y,GameConfig.playerHitArea, prevX,prevY);
    if(collisionData != null)
    {
      let v:Vector2 = new Phaser.Math.Vector2(this.vx,this.vy);
      let normal = collisionData.normal;
      let point = collisionData.point;
      let tmp:Vector2 = this.multiply(-2*this.dot(normal,v),normal);
      this.x = point.x;
      this.y = point.y;

      if(collisionData.tile.HitForce > 1)
      {
        this.hitObjectThatIncreasesVelocity();
      }
      this.vx += tmp.x*collisionData.tile.HitForce;
      this.vy += tmp.y*collisionData.tile.HitForce;
    }

    let bumperCollisionData = this.levelManager.hitBumper(this.x,this.y,GameConfig.playerHitArea, prevX,prevY);
    if(bumperCollisionData != null)
    {
      let v:Vector2 = new Phaser.Math.Vector2(this.vx,this.vy);
      let normal = bumperCollisionData.normal;
      let point = bumperCollisionData.point;
      let tmp:Vector2 = this.multiply(-2*this.dot(normal,v),normal);
      this.x = point.x;
      this.y = point.y;

      if(bumperCollisionData.wasDownLastFrame)
      {
        console.log("BOOSTED");
        this.vx += tmp.x*GameConfig.playerMaxSpeed// + Phaser.Math.Between(-10,10);
        this.vy += tmp.y*GameConfig.playerMaxSpeed;// + Phaser.Math.Between(-10,10);
        this.hitObjectThatIncreasesVelocity();
      }
      else
      {
        this.vx += tmp.x*(bumperCollisionData.tile.HitForce+Phaser.Math.Between(0,1));// + Phaser.Math.Between(-10,10);
        this.vy += tmp.y*(bumperCollisionData.tile.HitForce+Phaser.Math.Between(0,1));// + Phaser.Math.Between(-10,10);

        
      }
    }

    let critterHitData = this.levelManager.hitCritter(this.x,this.y,GameConfig.playerHitArea, prevX,prevY);
    if(critterHitData != null)
    {
      this.vx *= critterHitData.critter.HitForce;
      this.vy *= critterHitData.critter.HitForce; 

      if(critterHitData.critter.HitForce > 1)
      {
        this.hitObjectThatIncreasesVelocity();
      }
    }
  }

  private hitObjectThatIncreasesVelocity()
  {
    this.scene.sound.stopByKey(this.lastTazLaugh);
    this.lastTazLaugh = this.tazLaughs[Phaser.Math.Between(0,this.tazLaughs.length-1)];
    this.scene.app.AudioHandler.playSound(this.scene,this.lastTazLaugh , Sounds.Channel.SFX, { volume: 1});
    this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.ElasticSpring, Sounds.Channel.SFX, {
      volume: 0.8
    });

    this.scale = 1;
    this.taz.setColor(0xffff00);
    
    this.scene.add.tween({
      targets:this,
      
      scale:1.5,
      duration:400,
      yoyo:true,
      ease:Phaser.Math.Easing.Quadratic.InOut
    }).on("complete",()=>{
      this.scale = 1;
      this.taz.setColor(0xffffff);
    })

    this.scene.events.emit(Taz.events.SpeedBoost);
  }

  public get velocity()
  {
    return (Math.abs(this.vx)+Math.abs(this.vy));
  }

  public stop()
  {
    this.vx = 0;
    this.vy = 0;
    this.taz.state.timeScale = 1;
    this.taz.play(TazAnimations.Stop,false);
    this.taz.addAnimation(0,TazAnimations.Idle,true);
    this.manuallyStopped = true;

    this.scene.sound.stopByKey(Sounds.Track.TazWhirlLoop);
  }

  private multiply(multi:number, n:Vector2)
  {
    return new Phaser.Math.Vector2(n.x*multi,n.y*multi);
  }
  private dot(a:Vector2, b:Vector2)
  {
    return a.x*b.x + a.y*b.y;
  }
  private lerp (start:number, end:number, amt:number){
    return (1-amt)*start+amt*end
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.scene.app.AudioHandler.stopAndRemoveSound(this.tazWhirlLoopReference,Sounds.Channel.SFX);
    if(this.lastTazLaugh != "")
    {
    this.scene.sound.stopByKey(this.lastTazLaugh);
    }
    super.destroy(fromScene);
    
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
